import axios from 'axios';

// Créer une instance axios avec l'URL de base du serveur
const api = axios.create({
  baseURL: 'https://31.97.105.115.nip.io/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 60000 // 60 secondes par défaut
});

// Intercepteur pour les erreurs
api.interceptors.response.use(
  response => response,
  error => {
    // Log détaillé des erreurs
    console.error('API Error:', error.message);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      console.error('Headers:', error.response.headers);
    }
    return Promise.reject(error);
  }
);

export default api;
